import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RiderService } from '../rider.service';
import Swal from 'sweetalert2';
import { UserService } from '../../../users/user.service';
import { StaffService } from '../../../staff/staff.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-rider-dialog',
  templateUrl: './rider-dialog.component.html',
  styleUrls: ['./rider-dialog.component.scss']
})
export class RiderDialogComponent implements OnInit {
  form: FormGroup;
  loading = false;
  isEdit = false;
  users: any[] = [];
  staff: any[] = [];

  constructor(
    private fb: FormBuilder,
    private riderService: RiderService,
    private userService: UserService,
    private staffService: StaffService,
    private dialogRef: MatDialogRef<RiderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isEdit = !!data;
    this.form = this.fb.group({
      fullName: [data?.fullName || '', Validators.required],
      phoneNumber: [data?.phoneNumber || '', Validators.required],
      email: [data?.email || '', [Validators.email]],
      address: [data?.address || '', Validators.required],
      guarantorName: [data?.guarantorName || '', Validators.required],
      guarantorPhone: [data?.guarantorPhone || '', Validators.required],
      guarantorAddress: [data?.guarantorAddress || '', Validators.required],
      assignedPhoneModel: [data?.assignedPhoneModel || ''],
      assignedPhoneImei: [data?.assignedPhoneImei || ''],
      assignedPhoneNumber: [data?.assignedPhoneNumber || ''],
       userId: [data?.userId || ''],
       staffId: [data?.staffId || null],
      isActive: [data?.isActive ?? true]
    });
  }

  ngOnInit(): void {
    forkJoin({
      users: this.userService.getUsers(),
      staff: this.staffService.getAll()
    }).subscribe({
      next: ({ users, staff }) => {
        this.users = users || [];
        this.staff = staff || [];
      },
      error: () => {
        this.users = [];
        this.staff = [];
      }
    });
  }

  onSave(): void {
    if (this.form.invalid) {
      console.warn('%c[RiderDialog] ⚠️ Form is invalid:', 'color: orange', this.form.value);
      this.form.markAllAsTouched();
      return;
    }

    this.loading = true;
    const payload = this.form.value;
    console.log('%c[RiderDialog] 🚀 Submitting form...', 'color: blue', payload);

    const request = this.isEdit
      ? this.riderService.updateRider(this.data.id, payload)
      : this.riderService.createRider(payload);

    console.log('%c[RiderDialog] 📡 API Request initiated (isEdit=' + this.isEdit + ')', 'color: dodgerblue');

    request.subscribe({
      next: (res) => {
        console.log('%c[RiderDialog] ✅ API success response:', 'color: green', res);
        this.loading = false;
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: `Rider ${this.isEdit ? 'updated' : 'created'} successfully.`,
          confirmButtonText: 'OK'
        }).then(() => this.dialogRef.close(true));
      },
      error: (err) => {
        this.loading = false;
        console.error('%c[RiderDialog] ❌ API request failed:', 'color: red', err);
        Swal.fire('Error', 'Failed to save rider. Check console for details.', 'error');
      }
    });
  }

  onCancel(): void {
    console.log('%c[RiderDialog] 🟡 Cancel clicked', 'color: gray');
    this.dialogRef.close();
  }
}
